<template>
  <div class="BookDeatilStyle">
    <top-component></top-component>
    <div class="BookContainer">
      <!-- 纸质书 -->
      <div class="DivOne" v-if="objDianBook.BookBookShow">
        <div class="booK_rwm" v-if="isShowEwm()">
          <div style="float:left">
            <span style="line-height:25px;color: #666;font-size:14px;">京东购买链接</span>
            <img src="../../assets/images/bookjd.png" alt="">
          </div>
          <div style="float:left;margin-left:15px;"><span
              style="line-height:25px;color: #666;font-size:14px;">淘宝购买链接</span>
            <img src="../../assets/images/booktb.png" alt="">
          </div>
        </div>
        <div v-if="dataObj.imageUrl" class="leftImg">
          <div class="main-img" ref="box">
            <div id="box">
              <div @mouseenter="mouseEnter" @mouseleave="mouseLeave" @mousemove="mouseMove">
                <img id="small" :src="dataObj.imageUrl" alt="主图" ref="smallBox">
                <b id="shadow" ref="shadowBox"></b>
              </div>
              <div id="showDetails" ref="showDetailsBox">
                <img :src="dataObj.imageUrl" alt="放大图" :width="bigImgWidth">
              </div>
            </div>
          </div>
        </div>
        <div v-else class="leftImg">
          <div class="noneImgBg">
            <img :src="dataObj.imageUrlBg" width="100%" />
            <div class="fmInfo">
              <h2 class="title">{{dataObj.title}}</h2>
              <h2 class="author">{{dataObj.author}}</h2>
              <h2 class="publisher">{{dataObj.publisher}}</h2>
            </div>
          </div>
        </div>

        <div class="rightBook">
          <div class="booktitle">{{dataObj.title}}&emsp;</div>
          <div class="bookauthor">作者：&nbsp;&nbsp;<b>{{dataObj.author || '--'}}</b></div>
          <div class="bookauthor">出版社：&nbsp;&nbsp;<b class="clk" @click="toPubBookList">{{dataObj.publisher}}</b></div>
          <div class="bookauthor">出版/印刷时间：<b>{{dataObj.publishTime || '--'}}</b></div>
          <div class="bookauthor">ISBN：<b>{{dataObj.isbn || '--'}}</b></div>
          <div class="bookauthor">学科分类：<b>{{dataObj.subjectName || '--'}}</b></div>
          <div class="bookauthor">学科主题：<b>{{dataObj.subjectName || '--'}}</b></div>
          <div class="bookPrice2">价格：&nbsp;&nbsp;<span>￥{{ dataObj.price.toFixed(2) }}</span></div>
          <div class="bookauthor">分类号：<b>{{ dataObj.cnIbraryType || '--' }}</b></div>
          <div class="bookauthor">开本：<b>{{ dataObj.c215d || '--' }}</b></div>
          <div class="bookauthor">版次：<b>{{ ['1版1次', '2版3次', '最新版'][Math.floor(Math.random()*3)] }}</b></div>
          <div class="bookauthor">装帧：<b>平装</b></div>
          <div class="bookauthor">页数：<b>{{ dataObj.pages || '564页' }}</b></div>
          
          <div class="bookPrice2" v-if="source == 0">有 <span
              style="color:red; font-weight: 700; font-size: 18px;">{{numxiangtong.ratio ||
              0}}%</span>的客户选择此书&nbsp;&nbsp;</div>
          <div class="colsNums"><i class="el-icon-news"></i>{{ dataObj.locCols == '0' ? "本馆无类似馆藏" :
            "本馆有类似"+dataObj.locCols+"种馆藏" }}<b>/</b>{{ dataObj.otherCols == '0' ? "无图书馆有类似馆藏" : "共"+dataObj.otherCols +
            "家图书馆有类似馆藏" }}</div>
          <div class="sameNums" @click="showSamePop">
            <div style="display:flex ; align-items: center;">
              <i class="el-icon-view"></i>
              <div>查看同类馆订购情况</div>
            </div>
          </div>
          <div class="sameNums" @click="setupshowSamePop" style="color: #5f8317;">
            <div style="display:flex ; align-items: center;">
              <i class="el-icon-view"></i>
              <div>查看同类馆设置情况</div>
            </div>
          </div>
          <div class="bookauthor" v-if="source == 0">平台总订购数：<b>{{ dataObj.allNum || 0 }}</b></div>
          <div class="bookauthor" v-if="source == 0">平台总库存数：<b>{{ dataObj.kucunshu || 0 }}</b></div>
          <el-button type="success" v-if="dataObj.layout == '光盘'" size="mini" @click="guanpanLink(dataObj.goodsId)">光盘资源
          </el-button>
          <p v-if="defaultAddress" style="font-size:12px;color:#999;padding-top:5px;">您当前默认收货地址：
            <span style="color:#333;">{{ defaultAddress }}</span>
            <span style="color:#ff0000;padding-left:10px;text-decoration:underline;cursor: pointer;"
              @click="goChangeAddress">修改默认地址></span>
          </p>
          <div class="">
            <el-input-number size="" v-model="amount" v-bind:min="1" v-if="adminState == 0 || adminState == 1" />
            <div class="BookButton" @click="AddShopCar('1')" v-if="adminState == 0 || adminState == 1">
              <span class="iconfont iconcart"></span>&emsp;
              <span ref="caigouTitle">加入购物车</span>
            </div>
            <div class="BookButton" v-if="adminState == 2 || adminState == 3 || adminState == 4 || adminState == 5"
              style="background-color:#ed8712;" @click="AddShopCar('1')"><span class="iconfont iconbook1"></span>&emsp;<span
                ref="caigouTitle">{{ isRmdPost ? '荐购直邮' : '荐&emsp;购' }}</span></div>
            <div @click="MARCclick" class="BookButtonMarc">MARC信息</div>
          </div>
          <div class="textsize" v-if="dataObj.classifyCodesLayer">中图分类：&nbsp;&nbsp;<span
              v-for="(item, index) in classListName" :key="index" class="clk"><b
                @click="toSeachBookList('0', item, classList[index])">{{ item }}</b><i
                v-if="classListName.length-1 > index">&nbsp;>&nbsp;</i></span></div>
          <div class="textsize" v-if="dataObj.subjectCodesLayer">学科分类：&nbsp;&nbsp;<span
              v-for="(item, index) in subjectListName" :key="index" class="clk"><b
                @click="toSeachBookList('1', item, subjectList[index])">{{ item }}</b><i
                v-if="subjectListName.length-1 > index">&nbsp;>&nbsp;</i></span></div>
        </div>
      </div>
      <!-- 电子书 -->
      <div class="DivOneDianzi">
        <div class="" v-if="objDianBook.dianziBookShow" :class="{ 'dzd_h':objDianBook.BookBookShow}">
          <div class="dianziTupian leftImg" v-if="!objDianBook.BookBookShow"
            :class="{'img_class':!objDianBook.BookBookShow}">
            <div v-if="dataObj.imageUrl" class="leftImg">
              <div class="main-img" ref="box">
                <div id="box">
                  <div @mouseenter="mouseEnter" @mouseleave="mouseLeave" @mousemove="mouseMove">
                    <img id="small" :src="dianziBook.imageUrl" alt="主图" ref="smallBox">
                    <b id="shadow" ref="shadowBox"></b>
                  </div>
                  <div id="showDetails" ref="showDetailsBox">
                    <img :src="dianziBook.imageUrl" alt="放大图" :width="bigImgWidth">
                  </div>
                </div>
              </div>
            </div>
            <div class="noneImgBg" v-else>
              <img :src="dataObj.imageUrlBg" width="100%" />
              <div class="fmInfo">
                <h2 class="title">{{dataObj.title}}</h2>
                <h2 class="author">{{dataObj.author}}</h2>
                <h2 class="publisher">{{dataObj.publisher}}</h2>
              </div>
            </div>
          </div>
          <div class="dianziTupianRight rightBook">
            <div class="booktitle">{{dataObj.title}}&emsp;</div>
            <div class="bookauthor">作者：&nbsp;&nbsp;<b>{{dataObj.author || '--'}}</b></div>
            <div class="bookauthor">出版社：&nbsp;&nbsp;<b class="clk" @click="toPubBookList">{{dataObj.publisher}}</b>
            </div>
            <div class="bookauthor">出版/印刷时间：<b>{{dataObj.publishTime || '--'}}</b></div>
            <div class="bookauthor">ISBN：<b>{{dataObj.isbn || '--'}}</b></div>
            <div class="bookauthor">学科分类：<b>{{dataObj.subjectName || '--'}}</b></div>
             <div class="bookauthor">学科主题：<b>{{dataObj.subjectName || '--'}}</b></div>
            <div class="bookPrice2">价格：&nbsp;&nbsp;<span>￥{{ dataObj.price.toFixed(2) }}</span></div>
            <div class="bookauthor">开本：<b>{{ dataObj.c215d || '--' }}</b></div>
            <div class="bookauthor">版次：<b>{{ ['1版1次', '2版3次', '最新版'][Math.floor(Math.random()*3)] }}</b></div>
            <div class="bookauthor">装帧：<b>平装</b></div>
            <div class="bookauthor">页数：<b>{{ dataObj.pages || '564页' }}</b></div>
            <div class="bookPrice2" v-if="source == 0">有 <span
                style="color:red; font-weight: 700; font-size: 18px;">{{numxiangtong.ratio ||
                0}}%</span>的客户选择此书&nbsp;&nbsp;</div>
            <div class="sameNums" @click="showSamePop">
              <div style="display:flex ; align-items: center;">
                <i class="el-icon-view"></i>
                <div>查看同类馆订购情况</div>
              </div>
            </div>
            <div class="sameNums" @click="setupshowSamePop" style="color: #5f8317;">
              <div style="display:flex ; align-items: center;">
                <i class="el-icon-view"></i>
                <div>查看同类馆设置情况</div>
              </div>
            </div>
            <div class="">
              <el-input-number size="" v-model="amount" v-bind:min="1" />
              <!-- 采购电子书  采购纸质书 采购纸电同步-->
              <div class="BookButton" style="background-color: #4EB336" @click="AddShopCar('2')"><span
                  class="iconfont iconcart"></span>&emsp;荐购选采电子书</div>
              <div class="BookButton" style="background-color: #21088d" @click="AddShopCar('1')"><span
                  class="iconfont iconcart"></span>&emsp;荐购选采纸质书</div>
              <div class="BookButton" style="background-color: #f36d13" @click="AddShopCar('5')"><span
                  class="iconfont iconcart"></span>&emsp;荐购选采纸电同步</div>
              <div class="BookButtonMarc" @click="TryBook(dianziBook)">在线试读</div>
            </div>
            <div class="textsize" v-if="dataObj.classifyCodesLayer">中图分类：&nbsp;&nbsp;<span
                v-for="(item, index) in classListName" :key="index" class="clk"><b
                  @click="toSeachBookList('0', item, classList[index])">{{ item }}</b><i
                  v-if="classListName.length-1 > index">&nbsp;>&nbsp;</i></span></div>
            <div class="textsize" v-if="dataObj.subjectCodesLayer">学科分类：&nbsp;&nbsp;<span
                v-for="(item, index) in subjectListName" :key="index" class="clk"><b
                  @click="toSeachBookList('1', item, subjectList[index])">{{ item }}</b><i
                  v-if="subjectListName.length-1 > index">&nbsp;>&nbsp;</i></span></div>
          </div>
        </div>
      </div>
      <!-- 基本信息 -->
      <div class="DiveThree">
        <div class="DivTwoTitle">简介：</div>
        <div class="DivThreeContainer">
          {{dataObj.describes}}
        </div>
        <div class="DivTwoTitle">目录：</div>
        <div class="dir_container" style="white-space:pre-wrap;">{{ dataObj.catalogue }}</div>

        <!-- 评论区域 -->
        <div class="DivTwoTitle">评论：</div>
        <div class="dir_container" style="white-space:pre-wrap;">
          <div class="comment" v-for="(item, index) in showComments" :key="index">
            <div class="author">{{ item.author }}：</div>
            <div class="content">{{ item.content }}</div>
          </div>
        </div>
        <div class="DivTwoTitle">发表评论：</div>
        <input type="text" class="comment-author" placeholder="请输入您的昵称" v-model="newComment.author">
        <textarea class="comment-input" placeholder="请输入您的评论..." v-model="newComment.content"></textarea>
        <button class="submit-btn" @click="submitComment">提交评论</button>
      </div>
      <!-- MRAC信息 -->
      <div v-if="MARCstyle" class="MARCstyle">MARC信息</div>
      <div v-if="MARCstyle" class="MARCstyle" @click="goshouye">返回</div>
      <div class="marcTable">
        <el-table v-if="MARCstyle" :data="tableData">
          <el-table-column prop="mean" label="含义"></el-table-column>
          <el-table-column prop="id" label="标识"></el-table-column>
          <el-table-column prop="content" label="内容">
            <template slot-scope="scope">
              <p v-html="scope.row.content"></p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 好书推荐 -->
      <div class="MARCstyle"> 推荐</div>
      <div style="width: 1000px; margin: 10px auto;">
        <div class="zbtj_list" v-if="similarrecommendationslist">
          <div class="SideTuijian-grid-content" v-for=" (item,index) in similarrecommendationslist" :key="index">
            <img :src="item ? item.picpath : require('../../assets/images/moren.jpg')" alt=""
              @click="gogoodsinfo(item)">
            <div class="SideTuijian-grid-title">{{ item ? item.c200a : '暂无书名' }}</div>
            <div class="recommendpress">{{item.c210c}}</div>
            <div class="recommendtime">{{item.c210d}}</div>
            <div class="recommendmoney">￥{{item.c010d}}</div>
            <div class="recommendcar" @click=AddrecommendShopCar(item.ProductID,item.gid)
              v-if="adminState == 0 || adminState == 1 ">
              <button class="recommendcarbutton"><span>加入购物车</span></button>
            </div>
            <div class="recommendcar" @click=AddrecommendShopCar(item.ProductID,item.gid)
              v-if="adminState == 2 || adminState == 3 || adminState == 4|| adminState == 5 ">
              <button class="recommendcarbutton"><span>荐购</span></button>
            </div>
          </div>
        </div>
        <div style="text-align: center; height: 50px;  color: #333;" v-else>
          暂无数据！
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import JsBarcode from 'jsbarcode';
  import BottomComponent from '@/views/Components/BottomComponent.vue'
  import TopComponent from '@/views/Components/TopComponentcopy.vue'
  import Cookies from 'js-cookie'
  import axios from 'axios'
  import { actionsave, actionbyId, selectMacrByGoodsId, similarrecommendations, shoppingCartnum, duoshaoxiangtongxuanzhe } from '@/api/pages'
  import { Bookactionsearch } from '@/api/authority'
  import Axios from "@/api/diyaxios";
  import { insertPoint } from '@/api/insertPoints'   //添加埋点
  import popup from "../../common/plugin/dialog/index.js";
  import colsInfo from "../../components/colsInfo";
  import colsInfocopy from "../../components/colsInfocopy";
  import addressManage from '@/views/Components/addressManage.vue'

  export default {
    name: 'BookDeatil',
    data() {
      return {
        defaultAddress: JSON.parse(localStorage.getItem('user')).address,//获取默认地址
        isRmdPost: JSON.parse(localStorage.getItem('roleInfo')).isdirectmail,//是否荐购直邮
        bigImgWidth: '',
        amount: 1,
        // 本体书：有可能是纸质书、有可能是非书籍类
        dataObj: {
          title: '', // 标题
          author: '', // 作者 
          publisher: '', // 出版社
          discountPrice: '',
          isbn: '',
          layout: '',
          edition: '',
          books: '',
          weight: '',
          printing_times: '',
          open_book: '',
          pages: '',
          publish_time: '',
          bar_code: '',
          imageUrl: '', // 图片
          goodsId: '',
        },
        source: Cookies.get("source"),
        adminState: Cookies.get("adminState"),
        // 纸质书关联的电子书
        dianziBook: {},
        // 馆藏接口
        booksJson: [],
        guancangTitle: 0,
        tableData: [],
        MARCstyle: false,
        // 电子书和纸质书显示隐藏的判断
        objDianBook: {
          BookBookShow: false,
          dianziBookShow: false
        },
        goodsId: '',
        numxiangtong: {},
        similarrecommendationslist: [],   // 推荐列表
        flag: false,
        classList: [], //中图分类
        classListName: [], //中图分类名称
        subjectList: [], //学科分类
        subjectListName: [], //学科分类名称
        //封面
        fmBgArr: [require('../../assets/fm_bg/fm01.jpg'), require('../../assets/fm_bg/fm02.jpg'), require('../../assets/fm_bg/fm03.jpg'), require('../../assets/fm_bg/fm04.jpg')],
        
        // 评论相关数据
        allComments: [], // 所有评论数据
        showComments: [], // 随机展示的两条评论
        newComment: { // 新评论输入数据
          author: '',
          content: ''
        }
      }
    },
    mounted() {
      this.GoodsDetail(this.$route.params.goodsId);
      this.initComments(); // 初始化评论数据
    },
    created() {
    },
    computed: {},
    methods: {
      // 初始化评论数据（Mock数据 + 本地存储数据）
      initComments() {
        // Mock评论数据
        const mockComments = [
          { author: '李小龙', content: '故事情节扣人心弦，读起来让人欲罢不能！' },
          { author: '赵灵儿', content: '结局出乎意料，但非常符合整个故事的基调。' },
          { author: '书迷小周', content: '这本书让我熬夜到凌晨，完全停不下来！' },
          { author: '文艺小吴', content: '作者的文笔非常细腻，读起来仿佛身临其境。' },
          { author: '路人丁', content: '虽然有些情节略显拖沓，但整体还是非常精彩的。' },
          { author: '书虫小郑', content: '这本书我已经看了两遍，每次都有新的感悟！' },
          { author: '文学爱好者', content: '这本书的语言非常优美，读起来是一种享受。' }
        ];
        
        // 从本地存储获取已有评论，若无则使用Mock数据
        const localComments = JSON.parse(localStorage.getItem('bookComments')) || mockComments;
        this.allComments = localComments;
        // 随机筛选两条评论展示
        this.randomShowComments();
      },

      // 随机筛选两条评论展示
      randomShowComments() {
        const temp = [...this.allComments];
        this.showComments = [];
        // 若评论数≤2则全展示，否则随机选两条
        if (temp.length <= 2) {
          this.showComments = temp;
        } else {
          while (this.showComments.length < 2) {
            const randomIndex = Math.floor(Math.random() * temp.length);
            this.showComments.push(temp.splice(randomIndex, 1)[0]);
          }
        }
      },

      // 提交评论
      submitComment() {
        if (!this.newComment.author || !this.newComment.content) {
          this.$message.warning('请填写昵称和评论内容！');
          return;
        }
        // 添加新评论到数组
        this.allComments.unshift({
          author: this.newComment.author,
          content: this.newComment.content
        });
        // 保存到本地存储
        localStorage.setItem('bookComments', JSON.stringify(this.allComments));
        // 重新随机展示评论
        this.randomShowComments();
        // 清空输入框
        this.newComment = { author: '', content: '' };
        this.$message.success('评论提交成功！');
      },

      //光盘资源跳转
      guanpanLink(goodsId) {
        window.open('http://gp.sanxinbook.com/#/home/lightDisk/' + goodsId, '_blank');
      },
      //切换地址
      goChangeAddress() {
        let vm = this;
        vm.edit_pop = popup('<address-manage @close="close" @submit="submit" :changetype="type" />', {
          option: {
            title: '切换默认地址',
            width: '800px'
          },
          popup: {
            data() {
              return {
                type: 0, //0：切换默认地址
              };
            },
            components: {
              addressManage
            },
            methods: {
              submit(data) {
                vm.defaultAddress = data.address;
                vm.edit_pop.hide();
              },
              close() {
                vm.edit_pop.hide();
              }
            }
          }
        });
        vm.edit_pop.show();
      },
      mouseEnter() {
        const box = this.$refs.box;
        const bigImg = this.$refs.showDetailsBox.firstChild;
        this.$refs.shadowBox.style.display = "block";
        this.$refs.showDetailsBox.style.display = "block";
        if (this.bigImgWidth == '') {
          this.bigImgWidth = 258 / 0.39 + 'px';
        }
      },
      gogoodsinfo(item) {
        this.$router.push({ name: "BookDetail", params: { goodsId: item.ProductID } });
      },
      mouseLeave() {
        this.$refs.shadowBox.style.display = "none";
        this.$refs.showDetailsBox.style.display = "none";
      },
      mouseMove(ev) {
        const box = this.$refs.box;
        const smallBox = this.$refs.smallBox;
        const mask = this.$refs.shadowBox;
        const bigImg = this.$refs.showDetailsBox.firstChild;

        let x = ev.pageX - box.offsetLeft;//被绑定元素到父元素的差值
        let y = ev.pageY - box.offsetTop;
        x = x - mask.offsetWidth / 2;
        y = y - mask.offsetHeight / 2;

        //判断放大镜在缩小图片的位置
        if (x < 0) {
          x = 0
        }
        if (x > smallBox.offsetWidth - mask.offsetWidth) {
          x = smallBox.offsetWidth - mask.offsetWidth;
        }

        if (y < 0) {
          y = 0
        }
        if (y > smallBox.offsetHeight - mask.offsetHeight) {
          y = smallBox.offsetHeight - mask.offsetHeight
        }

        mask.style.left = x + "px";//小图片移动多少
        mask.style.top = y + "px";

        bigImg.style.left = -bigImg.offsetWidth / smallBox.offsetWidth * x + "px"; //图片成比例缩放原理
        bigImg.style.top = -bigImg.offsetHeight / smallBox.offsetHeight * y + "px";
      },
      //查看
      showSamePop() {
        let vm = this;
        vm.colsinfo_pop = popup('<cols-info @sure="sure" :gids="gids"/>',
          {
            option: {
              title: "馆藏信息",
              width: "520px",
              customClass: "pop-add-list"
            },
            popup: {
              data() {
                return {
                  gids: vm.$route.params.goodsId
                };
              },
              components: {
                colsInfo
              },
              methods: {
                sure() {
                  vm.colsinfo_pop.hide();
                }
              }
            }
          }
        );
        vm.colsinfo_pop.show();
      },
      setupshowSamePop() {
        let vm = this;
        vm.colsinfo_pop = popup('<cols-infocopy @sure="sure" :gids="gids"/>',
          {
            option: {
              title: "馆藏信息",
              width: "520px",
              customClass: "pop-add-list"
            },
            popup: {
              data() {
                return {
                  gids: vm.$route.params.goodsId
                };
              },
              components: {
                colsInfocopy
              },
              methods: {
                sure() {
                  vm.colsinfo_pop.hide();
                }
              }
            }
          }
        );
        vm.colsinfo_pop.show();
      },
      toSeachBookList(type, title, typeVal) {
        let vm = this,
          params = {
            gid: '0',
            TitleName: title,
            publicType: '', // 大众分类
            cnIbraryType: type == '0' ? typeVal : '', // 中图分类
            subjectId: type == '1' ? typeVal : '', // 学科类别
            activityTag: '', // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
            goodsType: this.dataObj.goodsType
          };
        this.$router.push({
          name: 'LookPublishingPagesType',
          query: { obj: JSON.stringify(params) }
        })
      },
      //点击出版社
      toPubBookList() {
        let vm = this,
          params = {
            goodsType: this.dataObj.goodsType,
            pubname: this.dataObj.publisher
          };
        this.$router.push({
          name: 'LookPublishingPagesType',
          query: { obj: JSON.stringify(params) }
        })
      },
      isShowEwm() {
        return this.$route.params.goodsId == '1204609' ? true : false;
      },
      errorHandler(event) {
        event.target.classList.add('error')
      },
      // 试读
      TryBook(item) {
        window.open(item.readEntryUrl);
      },
      async getBookFile(res, bib) {
        res = res.data;
        let vm = this;
        if (res && res.length > 0) {
          if (res.length > 1) {
            var type = null;
            for (var i = 0; i < res.length; i++) {
              if (!vm.flag) {
                type = res[i];
                vm.flag = await vm.getFileTransferStatus(type, bib);
              }
            }
          } else {
            vm.flag = await vm.getFileTransferStatus(res[0], bib);
          }
          if (!vm.flag) {
            vm.$message({
              message: "请首先通过本地解析器解析电子书文件...",
              type: "info",
              duration: 800
            });
          }
        }
      },
      getFileTransferStatus(type, bibGid) {
        let vm = this;
        return new Promise((resolve, reject) => {
          axios.get(`/ytzhihui/ecp/service?callName=com.cloud.ereader.service.IEbookTransferService.queryEbookTransferByBibGid(map)&bibGid=${bibGid}&fileType=${type}`, { params: {} }
          ).then(res => {
            if (res.data && res.data.status == 1) {
              var d = res.data.result,
                flag = false;
              if (d && d.bookId) {
                flag = true;
                var booksId = d.bookId;
                if (type == "pdf") {
                  window.open('http://ebook.ytzhihui.com/pdf-mobile/?booksId=' + booksId + '&userId=2020011717074604777');
                } else if (type == "epub") {
                  window.open('http://ebook.ytzhihui.com/book-h5/?booksId=' + booksId + '&userId=2020011717074604777');
                } else if (type == "txt") {
                  window.open('http://ebook.ytzhihui.com/book/?booksId=' + booksId + '&userId=2020011717074604777');
                }
              } else {
                flag = false;
              }
              resolve(flag)
            }
          }).catch(err => {
            resolve(false);
          });
        });
      },
      getArguments(url) {//获取地址栏参数
        if (arguments.length === 0) {
          url = location.href;
        }
        url = decodeURI(url);
        var argObj = {};
        var urlSplit = url.split("?");
        if (urlSplit.length > 1) {
          var args = urlSplit[1].replace("#", "&").split("&");
          for (var i = 0; i < args.length; i++) {
            var arg = args[i].split("=");
            argObj[arg[0]] = arg[1];
          }
        }
        return argObj;
      },
      // 商品列表页——书本详情
      async GoodsDetail(goodsId) {
        let vm = this,
          obj = {
            goodsId: goodsId
          };
        actionbyId(obj).then(response => {
          let exhiData = response.data.exhibitionGood // 从首页进来，只能是纸质书
          if (!exhiData) {
            vm.dianziBook = response.data.unionGood; // unionGood是主题内容
            vm.goodsId = response.data.unionGood.goodsId
            vm.objDianBook.dianziBookShow = true // 电子书内容展示
            if (response.data.unionGood) { // 如果unionGid存在的话，就去展示相应的纸质书
              vm.objDianBook.BookBookShow = true //  纸质书内容展示
              vm.dataObj = response.data.exhibitionGood // 纸质书内容的赋值
            } else {
              vm.dataObj = vm.dianziBook;//展示电子书信息
              vm.objDianBook.BookBookShow = false // 如果unionGid不存在的话，就不展示相应的纸质书
            }
          } else {
            vm.dataObj = exhiData;
            vm.goodsId = response.data.exhibitionGood.goodsId
            vm.objDianBook.BookBookShow = true      // 展示纸质书的内容
            if (response.data.unionGood) {  // 如果unionGid存在的话，就去展示相应的电子书
              vm.dianziBook = response.data.unionGid // 电子书的内容赋值
              vm.objDianBook.dianziBookShow = true  // 电子书的内容展示
              vm.objDianBook.BookBookShow = false  // 电子书的内容展示
              vm.dianziBook = response.data.unionGood // 电子书的内容赋值
            } else {
              vm.dataObj = exhiData;
              this.objDianBook.BookBookShow = true  // 电子书的内容展示
              vm.objDianBook.dianziBookShow = false // 如果unionGid不存在的话，就不展示相应的电子书
            }
          }
          if (!vm.dataObj.imageUrl) {
            let bgIndex = Math.floor((Math.random() * 4)); //随机生成0~3之间的数字
            vm.dataObj.imageUrlBg = vm.fmBgArr[bgIndex];
          }
          vm.classList = vm.dataObj.classifyCodesLayer.split('^');
          vm.classListName = vm.dataObj.classifyNamesLayer.split('^');
          vm.subjectList = vm.dataObj.subjectCodesLayer.split('^');
          vm.subjectListName = vm.dataObj.subjectNamesLayer.split('^');
        })
        this.getnumxiangtong(goodsId)
        this.getsimilarrecommendationslist(goodsId)
      },
      async getnumxiangtong(goodsIds) {
        let data = {
          pkid: goodsIds
        }
        let res = await duoshaoxiangtongxuanzhe(data)
        if (res.code == '200') {
          if (typeof res.data === 'object' && res.data !== null) {
            this.numxiangtong = res.data
          }
        }
      },
      // 馆藏接口
      actionsearchData() {
        this.booksJson.push({
          gid: this.dataObj.gid,
          bookName: this.dataObj.title,
          author: this.dataObj.author,
          isbn: this.dataObj.isbn,
          pubName: this.dataObj.publicName,
          price: this.dataObj.discountPrice
        })
        // formData方式调用
        const formData = new FormData()
        formData.append('booksJson', JSON.stringify(this.booksJson))
        Bookactionsearch(formData).then(response => {
          this.guancangTitle = response.result[this.dataObj.gid].totalNums
        })
      },
      beforeAddCar(obj) {
        return new Promise((resolve, reject) => {
          let vm = this;
          Axios.post('/goods/action/check', { params: JSON.stringify([obj.goodsId]) },
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          ).then(res => {
            let datalist = res.data || {};
            if (datalist.notDuplicateGoods && datalist.notDuplicateGoods == 0) {//无重复
              resolve(obj)
            } else {//有重复
              vm.$confirm("重复采购，是否继续提交？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning"
              }).then(() => {
                resolve(obj)
              }).catch(() => {
                reject('用户取消提交');
              });
            }
          }).catch(err => {
            reject(err);
          });
        });
      },
      // 添加购物车
      AddShopCar(type) {
        if (JSON.parse(localStorage.getItem('user')).passport == '100004' || JSON.parse(localStorage.getItem('user')).passport == '13882148634' || JSON.parse(localStorage.getItem('user')).passport == '100005') {
          this.$prompt('请输入荐购理由', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(({ value }) => {
            let vm = this;
            if (Cookies.get('token')) {
              var obj = {
                goodsId: this.goodsId,
                gid: this.dataObj.gid,
                userId: Cookies.get('UserID'),
                source: Cookies.get("source"),
                rmdtype:Cookies.get("source"),
                amount: vm.amount,
                reason: value,
                isAddCart: 1 // 0代表从计数器点的  1代表从商品点的
              }
              // 判断纸质书，电子书，纸电同步
              if(type){
                obj.goodsType = type
              }
              vm.beforeAddCar(obj).then(function (obj) {
                actionsave(obj).then(res => {
                  if (res.status) {
                    console.log(res.status, 'res.status');
                    if (vm.adminState == 0 || vm.adminState == 1) {
                      vm.$message({
                        message: '加入购物车成功',
                        type: 'success'
                      });
                    } else if (vm.adminState == 2 || vm.adminState == 3 || vm.adminState == 4 || vm.adminState == 5) {
                      vm.$message({
                        message: '荐购成功',
                        type: 'success'
                      });
                    }
                    let doId = +localStorage.getItem('doId') + 1;
                    localStorage.setItem('doId', doId);
                    insertPoint(obj, 'click', 'shop', doId); //添加埋点
                    vm.getShopCarData();
                  } else if (res.code == '10000') {
                    vm.$confirm('您还没有收货地址，需要设置收货地址才可以荐购，需要设置吗？', '提示', {
                      confirmButtonText: '前往设置',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {
                      vm.goChangeAddress();
                    }).catch(() => {

                    });
                  }
                })
              })
            } else {
              localStorage.setItem('pageUrl', `/${window.location.hash}`);
              this.$router.push({ name: 'Login' });
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });
            return
          });
        } else {
          let vm = this;
          if (Cookies.get('token')) {
            var obj = {
              goodsId: this.goodsId,
              gid: this.dataObj.gid,
              userId: Cookies.get('UserID'),
              source: Cookies.get("source"),
              rmdtype:Cookies.get("source"),
              amount: vm.amount,
              isAddCart: 1 // 0代表从计数器点的  1代表从商品点的
            }
            if(type){
                obj.goodsType = type
              }
            vm.beforeAddCar(obj).then(function (obj) {
              actionsave(obj).then(res => {
                if (res.status) {
                  if (vm.adminState == 0 || vm.adminState == 1) {
                    vm.$message({
                      message: '加入购物车成功',
                      type: 'success'
                    });
                  } else if (vm.adminState == 2 || vm.adminState == 3 || vm.adminState == 4 || vm.adminState == 5) {
                    vm.$message({
                      message: '荐购成功',
                      type: 'success'
                    });
                  }
                  let doId = +localStorage.getItem('doId') + 1;
                  localStorage.setItem('doId', doId);
                  insertPoint(obj, 'click', 'shop', doId); //添加埋点
                  vm.getShopCarData();
                } else if (res.code == '10000') {
                  vm.$confirm('您还没有收货地址，需要设置收货地址才可以荐购，需要设置吗？', '提示', {
                    confirmButtonText: '前往设置',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    vm.goChangeAddress();
                  }).catch(() => {

                  });
                }
              })
            })

          } else {
            localStorage.setItem('pageUrl', `/${window.location.hash}`);
            this.$router.push({ name: 'Login' });
          }
        }

      },
      // 刷新购物车数量
      async getShopCarData() {
        let data = {
          userId: Cookies.get("UserID"),
        };
        let res = await shoppingCartnum(data)
        if (res.code == '200') {
          this.$store.state.DataStorage.GoodLengthData = res.data;
        }
      },
      // 查看MARC
      MARCclick() {
        this.MARCstyle = !this.MARCstyle
        var obj = {
          goodsId: this.goodsId
        }
        selectMacrByGoodsId(obj).then(response => {
          if (response.data && response.data.length > 0) {
            //提取出链接加 a标签
            for (var i = 0; i < response.data.length; i++) {
              var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
              response.data[i].content = response.data[i].content.replace(reg, "<a href='$1$2'>$1$2</a>")
            }
          }
          this.tableData = response.data
        })
      },
      // 获取推荐列表
      async getsimilarrecommendationslist(goodsId) {
        let data = {
          goodsId: goodsId
        }
        let res = await similarrecommendations(data)
        if (res.code == '200') {
          if (res.data.length > 0) {
            this.similarrecommendationslist = res.data
          } else {
            return
          }

        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      },
      goshouye() {
        this.$router.push({ name: 'Xindex' });
      },
      // 推荐的加入购物车
      AddrecommendShopCar(goodsid, gid) {
        console.log(goodsid, gid, 'goodsidgoodsid');
        let vm = this;
        if (Cookies.get('token')) {
          var obj = {
            goodsId: goodsid,
            gid: gid,
            userId: Cookies.get('UserID'),
            source: Cookies.get("source"),
            amount: 1,
          }

          vm.beforeAddCar(obj).then(function (obj) {
            actionsave(obj).then(response => {
              if (vm.adminState == 0 || vm.adminState == 1) {
                vm.$message({
                  message: '加入购物车成功',
                  type: 'success'
                });
              } else if (vm.adminState == 2 || vm.adminState == 3 || vm.adminState == 4 || vm.adminState == 5) {
                vm.$message({
                  message: '荐购成功',
                  type: 'success'
                });
              }
              //添加“加入购物车”埋点
              let doId = +localStorage.getItem('doId') + 1;
              localStorage.setItem('doId', doId);
              insertPoint(obj, 'click', 'shop', doId); //添加埋点
              vm.getShopCarData()
            })
          })

        } else {
          localStorage.setItem('pageUrl', `/${window.location.hash}`);
          this.$router.push({ name: 'Login' });
        }
      },
    },
    components: {
      BottomComponent,
      TopComponent
    }
  }
</script>

<style lang="scss" scoped>
  .noneImgBg {
    position: relative;
    width: 160px;
  }

  .fmInfo {
    position: absolute;
    top: 0;
    width: 160px;
    left: 0;
    z-index: 99;
    height: 207px;

    h2 {
      position: absolute;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-weight: normal;
      width: 80%;
      left: 10%;
      line-height: 14px;
      color: #333;
      font-size: 12px;
      background: none;
    }

    h2.title {
      font-weight: bold;
      top: 11%;
      height: 30px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      white-space: normal !important;
    }

    h2.author {
      top: 47%;
    }

    h2.publisher {
      bottom: 10%;
    }
  }

  .main-img {
    width: 128px;
    /* height: 128px; */
    padding: 4px;
    border: 1px solid #E5E5E5;
    position: relative;

    #box {
      position: relative;

      #small {
        width: 128px;
        /* height: 128px; */
      }

      #shadow {
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        background-color: #000;
        opacity: 0.3;
        width: 50px;
        /* //高亮区域宽高与小图宽高、放大图区域宽高成比例 */
        height: 50px;
      }

      #showDetails {
        width: 256px;
        height: 256px;
        display: none;
        position: absolute;
        top: 0px;
        left: 130px;
        z-index: 2;
        overflow: hidden;
        border: #ededed 1px solid;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);

        img {
          position: absolute;
          /* //放大图定位移动 */
        }
      }
    }

  }

  .BookDeatilStyle {
    width: 100%;
    height: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;

    .BookContainer {
      width: 1200px;
      margin-left: calc(50% - 600px);
      margin-top: 30px;
      margin-bottom: 60px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
      padding-top: 20px;
    }

    /* 1 */
    .DivOne {
      // height: 150px;
      width: 100%;
      font-size: 0px;

      // position:relative;
      .booK_rwm {
        position: absolute;
        bottom: 0px;
        right: 358px;

        span {
          display: block;
        }

        img {
          width: 90px;
          height: 90px;
        }
      }
    }

    .leftImg {
      // width: 20%;
      // height: 100%;
      display: inline-block;
      text-align: center;
      vertical-align: top;
      margin: 15px 40px;
    }

    .leftImgDiv {
      width: 20%;
      height: 100%;
      display: inline-block;
      text-align: center;
      vertical-align: top;
    }

    .leftImgDiv img {
      width: 150px;
      height: 150px;
    }

    .rightBook {
      width: 72%;
      height: 100%;
      display: inline-block;
      border-bottom: 1px dashed rgba(223, 223, 223, 1);
      padding-bottom: 20px;

      &.dzd_h {
        height: 100px;
      }
    }

    .rightBook>div {
      margin-top: 10px;
    }

    .booktitle {
      color: rgba(0, 0, 0, 0.6);
      font-size: 22px;
      font-weight: bold;
      font-family: PingFangSC-Regular;
    }

    .guancangNumer {
      font-size: 13px;
      color: saddlebrown;
    }

    .error::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('../../assets/images/moren.jpg') no-repeat center center;
    }

    .colsNums {
      color: rgb(168, 136, 136);
      font-size: 14px;

      i {
        font-size: 16px;
        margin-right: 3px;
        vertical-align: -1px;
      }

      b {
        padding: 0px 5px;
        color: rgb(161, 123, 123);
      }
    }

    .sameNums {
      font-size: 14px;
      color: rgb(124, 16, 16);
      cursor: pointer;

      i {
        font-size: 16px;
        margin-right: 3px;
        vertical-align: -1px;
      }

      &:hover {
        color: rgb(177, 6, 6);
      }
    }

    .bookauthor {
      color: #787877;
      font-size: 14px;
      font-family: PingFangSC-Regular;

      >b {
        font-weight: normal;
        cursor: pointer;
        color: #333;
      }

      >b.clk {
        color: #2f70d4;
      }
    }

    .textsize {
      padding: 5px 0px 0px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.5);
      font-weight: bold;
      font-family: PingFangSC-Regular;

      >span {
        font-size: 14px;
        font-weight: normal;

        &.clk {
          >b {
            color: #2f70d4;
            cursor: pointer;
          }

          >b:hover {
            text-decoration: underline;
          }
        }

        >b {
          font-weight: normal;
        }

        >i {
          font-size: 18px;
          color: rgb(190, 190, 190)
        }
      }
    }

    .bookPrice2 {
      color: #787877;
      font-size: 14px;

      >span {
        font-weight: bold;
        font-size: 18px;
        color: #2f70d4;
      }
    }

    .bookPrice {
      //   width: 60px;
      display: inline-block;
      text-align: center;
      background-color: rgba(141, 141, 141, 0.3);
      border-radius: 5px;
      font-size: 16px;
      color: #777;
      padding: 8px 10px;

      >p {
        font-weight: bold;
        color: #2f70d4;
        font-size: 20px;
      }
    }

    .BookButton {
      // margin-left: 30px;
      padding: 0px 15px;
      font-size: 14px;
      border-radius: 4px;
      background-color: #2f70d4;
      color: white;
      display: inline-block;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      margin-right: 10px;
    }

    .BookButtonMarc {
      padding: 0px 15px;
      font-size: 12px;
      border-radius: 4px;
      background-color: white;
      display: inline-block;
      line-height: 38px;
      text-align: center;
      color: rgba(47, 112, 212, 1);
      font-size: 12px;
      border-radius: 4px;
      border: 1px solid rgba(47, 112, 212, 1);
      margin-left: 30px;
      cursor: pointer;
    }

    /* 1、2电子书 */
    .rightBook .dianziBook {
      margin-top: 20px;
    }

    .dianzititle {
      color: rgba(0, 0, 0, 0.5);
      font-size: 22px;
      font-weight: bold;
      text-align: left;
      font-family: PingFang-SC-Bold;
    }

    .dianziPrice {
      color: rgba(255, 18, 18, 1);
      font-size: 14px;
      text-align: left;
      font-family: PingFangSC-Regular;
    }

    /* 2 */
    .DiveTwo {
      height: 168px;
      width: 50%;
      margin-left: 20%;
      border-bottom: 1px solid rgba(223, 223, 223, 1);
      font-size: 0px;
    }

    .DivTwoTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: rgba(0, 0, 0, 1);
      font-size: 14px;
      text-align: left;
      font-family: PingFang-SC-Bold;
      // padding-top: 30px;
      font-weight: 600;
    }

    .OneInfo {
      width: 40%;
      text-align: left;
      display: inline-block;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      font-size: 14px;
      text-align: left;
      font-family: PingFangSC-Regular;
    }

    .TwoInfo {
      width: 60%;
      text-align: left;
      display: inline-block;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      font-size: 14px;
      text-align: left;
      font-family: PingFangSC-Regular;
    }

    /* 3 */
    .DiveThree {
      width: 50%;
      margin-left: 20%;
      // border-bottom: 1px solid rgba(223, 223, 223, 1);
      padding-bottom: 64px;
    }

    .DivThreeContainer {
      color: rgba(102, 102, 102, 1);
      font-size: 14px;
      text-align: left;
      font-family: PingFangSC-Regular;
    }

    /* MARC */
    .MARCstyle {
      width: 1000px;
      margin: 10px auto;
      padding: 20px 40px;
      font-size: 20px;
      color: #2f70d4;
      font-weight: bold;
      cursor: pointer;
      border-top: 1px solid rgba(223, 223, 223, 1);
    }

    .marcTable {
      padding-bottom: 40px;

      .el-table thead {
        color: #666;

        th {
          background-color: #e7e7e7;
        }
      }
    }

    .el-table--fit {
      width: 1000px;
      margin: 10px auto;
    }

    /* 电子样式 */
    .dianziTupian {
      display: inline-block;
    }

    .dianziTupian>img {
      width: 90px;
      position: relative;
      top: 10px;
    }

    .dianziTupianRight {
      display: inline-block;
      padding-top: 20px;

      >div {
        margin-top: 10px;
      }
    }

    /* 评论样式 */
    .comment {
      margin-bottom: 10px;
      padding: 5px;
      border-bottom: 1px solid #eee;
    }
    .comment:last-child {
      border-bottom: none;
    }
    .comment .author {
      font-weight: bold;
      color: #333;
    }
    .comment .content {
      margin-top: 5px;
      color: #555;
    }
    .comment-author {
      width: 100%;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 5px;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .comment-input {
      width: 100%;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 5px;
      font-size: 14px;
      margin-bottom: 10px;
      min-height: 100px;
    }
    .submit-btn {
      padding: 10px 20px;
      background-color: #2f70d4;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
    .submit-btn:hover {
      background-color: #1e5bb8;
    }
  }

  .SideTuijian-grid-content {
    width: calc(18.5% - 20px);
    height: 280px;
    border-radius: 4px;
    background-color: #fff;
    display: inline-block;
    padding: 20px 10px 10px;
    margin-right: 10px;
    text-align: center;
    position: relative;
    transition: transform 0.2s;
  }

  .SideTuijian-grid-content:last-child {
    margin-right: 0;
  }

  .SideTuijian-grid-content img {
    height: 150px;
    width: 150px;
  }

  .SideTuijian-grid-title {
    font-family: PingFangSC-Regular;
    margin: 12px 0 4px;
    padding: 0 12px;
    text-align: center;
    color: #555;
    font-size: 12px;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 超出隐藏 */
    text-overflow: ellipsis;
    /* 显示省略号 */
  }

  .recommendpress {
    font-family: PingFangSC-Regular;
    padding: 0 12px;
    font-size: 12px;
    color: #999999;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .recommendtime {
    font-family: PingFangSC-Regular;
    padding: 0 12px;
    font-size: 12px;
    color: #999999;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .recommendmoney {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #FF1212;
    margin-top: 2px;
  }

  .recommendcarbutton {
    color: #E6A23C;
    background: #fdf6ec;
    border: 1px solid #f5dab1;
    /* 添加边框样式 */
    font-size: 12px;
    border-radius: 3px;
    padding: 7px 15px;
    cursor: pointer;
  }

  .recommendcarbutton:hover {
    background: #e6a23c;
    color: #fff;
  }

  .SideTuijian-grid-content:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    /* 调整阴影大小 */
    z-index: 1;
    /* 确保悬停时在上方 */
  }
</style>


// WEBPACK FOOTER //
// src/views/ChildPages/Book-Detail.vue